import type { PDFDocumentProxy } from 'pdfjs-dist'

import { downloadBlob } from 'modules/core/lib/download'

const getPdfBlob = async (pdf: PDFDocumentProxy): Promise<Blob> => {
  const data = await pdf.saveDocument()
  return new Blob([data as BlobPart], { type: 'application/pdf' })
}

const printPdf = async (pdf: PDFDocumentProxy | null): Promise<void> => {
  if (!pdf) return

  const blob = await getPdfBlob(pdf)
  const blobUrl = URL.createObjectURL(blob)

  const iframe = document.createElement('iframe')
  document.body.appendChild(iframe)

  iframe.style.display = 'none'
  iframe.src = blobUrl
  iframe.onload = function () {
    iframe.focus()
    if (iframe.contentWindow) {
      iframe.contentWindow.print()
    }
  }
}

const downloadPdf = async (pdf: PDFDocumentProxy | null, filename: string): Promise<void> => {
  if (!pdf) return

  const blob = await getPdfBlob(pdf)
  downloadBlob(blob, filename)
}

export interface PageSize {
  width: number
  height: number
}

export { printPdf, downloadPdf }
